<template>
  <c-page class="s-actionsheet-container">
    <div class="industry-modal">
      <div class="pt-20 pb-10 modal-item-block price-item">
        <div class="modal-title">选择时长</div>
        <div class="modal-content">
          <div class="ds-flex item-panel">
            <label
              class="item-version"
              :class="{'active': cItem.isChecked}"
              :key="index"
              v-for="(cItem, index) in versionItem"
              @click="val => changeVersion(val, cItem)"
            >
              <input
                type="checkbox"
                class="weui-check"
                :value="cItem.isChecked"
                @input="val => changeVersion(val, cItem)"
              >
              <div>
                <img
                  v-if="cItem.type === 'year'"
                  class="item-tag"
                  src="../../../../../assets/images/industry-version/sale-tag@2x.png"
                  alt="折扣"
                >
                <span class="origin-price">{{cItem.oriPrice}}</span>
                ￥ <span class="price">{{cItem.realPrice}}</span>/{{cItem.typeText}}
              </div>
            </label>
          </div>
        </div>
      </div>
    </div>
    <c-content>
      <div class="modal-item-block">
        <div class="modal-title">选择行业</div>
        <div class="mt-0 modal-content">
          <c-cell-checkbox
            v-for="item in versionEntity"
            :key="item.id"
            :value="item.isChecked"
            :class="{'disabled': !item.isAvailable}"
            @input="val => checkChange(val,item)"
            :point="false"
          >
            <div
              class="goods-icon"
              slot="header"
            ><img
                :src=item.icon
                alt=""
              ></div>
            <div
              class="ml-5 text-elps goods-desc"
              slot="body"
            >
              <div>{{item.name}}</div>
              <div class="mt-10 text-elps text-color gray item-desc">{{item.desc}}</div>
            </div>
          </c-cell-checkbox>
        </div>
      </div>
    </c-content>
    <c-footer>
      <c-button @click.native="orderConfirm">立即购买</c-button>
    </c-footer>
  </c-page>
</template>
<style lang="scss" scoped>
@import "./index.scss";
</style>
<style lang="scss">
.version-cell-item {
  .weui-cell-title {
    font-weight: 600;
  }
}
</style>
<script>
export default {
  props: {
    versionEntity: {
      type: Array,
      default: []
    },
    defaultType: {
      type: String,
      default: 'year'
    },
    priceObj: {
      type: Object,
      default () {
        return {}
      }
    },
    oldUser: {
      oriPrice: '588',
      salePrice: '288'
    },
    newUser: {
      oriPrice: '720',
      salePrice: '588'
    }
  },
  data () {
    return {
      salesType: 1,
      versionItem: [],
      payObj: {}
    }
  },
  components: {},
  created () {
  },
  mounted () {
    this.initBuyType(this.defaultType)
  },
  beforeDestroy () {
  },
  methods: {
    initPriceType () {
      this.versionItem.forEach(item => {
        if (item.type === 'year') {
          item.oriPrice = this.priceObj.oriPrice
          item.realPrice = this.priceObj.salePrice
        }
      })
    },
    initBuyType (val = 'year') {
      this.versionItem.forEach(item => {
        item.isChecked = false
        if (item.type === val) {
          item.isChecked = true
        }
      })
    },
    checkChange (val, item) {
      this.versionEntity.forEach(cItem => {
        if (!item.isAvailable) return
        cItem.isChecked = cItem === item
      })
    },
    changeVersion (val, item) {
      this.versionItem.forEach(cItem => {
        cItem.isChecked = cItem === item
      })
    },
    orderConfirm () {
      let checkedIndustry = this.versionEntity.filter(cItem => {
        return cItem.isChecked
      }).length === 0
      if (checkedIndustry) return this.$wejs.alert('请选择您要购买的版本')
      this.$emit('pay', this.getPayObj())
    },
    getPayObj () {
      let payObj = {
        quantity: 12
      }
      this.versionItem.map(item => {
        if (item.isChecked && item.type === 'month') {
          payObj.quantity = 1
        }
      })
      this.versionEntity.forEach(item => {
        if (item.isChecked) {
          payObj.goodsId = item.id
        }
      })
      return payObj
    }
  },
  computed: {
    userInfo: {
      get () {
        return this.$store.getters[`userInfo/getUserInfo`]
      }
    }
  },
  watch: {
    defaultType: {
      handler: function (val) {
        this.initBuyType(val)
      },
      deep: true
    },
    priceObj: {
      handler: function (val) {
        this.initPriceType()
      },
      deep: true
    },
    userInfo: {
      handler: function (val) {
        if (val.saasOrderCount > 0) {
          this.versionItem = [{
            type: 'year',
            isChecked: true,
            oriPrice: '720',
            realPrice: '599',
            typeText: '年'
          }]
        } else {
          this.versionItem = [{
            type: 'month',
            isChecked: false,
            oriPrice: '',
            realPrice: '60',
            typeText: '月'
          },
          {
            type: 'year',
            isChecked: false,
            oriPrice: '720',
            realPrice: '599',
            typeText: '年'
          }]
        }
      },
      deep: true,
      immediate: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?e878734c